<template>
  <li class="restaurant__card">
    <a
      :href="content.website"
      :title="content.title"
      target="_blank"
      class="restaurant__card-image"
    >
      <Image :source="content.image" />
    </a>
    <AddressLink :content="addressLink" class="restaurant__card-address" />
    <a :href="content.website" target="_blank" class="restaurant__link">
      <span>{{ $t('home.VisitTheWebsite') }}</span>
      <Icon id="arrow" class="restaurant__arrow" />
    </a>
  </li>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import Image from '@/components/global/Image.vue'
import AddressLink from '@/components/small/AddressLink.vue'

export default {
  name: 'RestaurantCard',
  components: {
    AddressLink,
    Icon,
    Image,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  computed: {
    addressLink() {
      return {
        address: this.content.address,
        city: this.content.city,
        link: this.content.map_link,
        postal_code: this.content.postal_code,
        state: this.content.state,
      }
    },
  },
}
</script>
